import React from 'react';
import ChatList from './ChatList';
import ChatAccessGate from '@/components/chat/ChatAccessGate';

const ChatListPage = () => {
  return (
    <ChatAccessGate options={{ context: 'list' }}>
      <ChatList 
        variant="standalone" 
        showHeader={true} 
        className="pt-20"
      />
    </ChatAccessGate>
  );
};

export default ChatListPage;